import { useService } from 'react-reservice';

import demoCreationService from './service';

export const useDemoCreation = () => {
  return useService(demoCreationService, (state) => state);
};

export { demoCreationService };
